import { React, PropTypes } from 'imports';
import Typedjs from 'static/typed';
import './Typed.less';

export default class Typed extends React.Component {
    get PropTypes() {
        return {
            className: PropTypes.string,
            options: PropTypes.shape({
                strings: PropTypes.arrayOf(PropTypes.string),
                stringsElement: PropTypes.instanceOf(window.Node),
                typeSpeed: PropTypes.int,
                startDelay: PropTypes.int,
                backSpeed: PropTypes.int,
                shuffle: PropTypes.bool,
                backDelay: PropTypes.int,
                fadeOut: PropTypes.bool,
                fadeOutClass: PropTypes.string,
                fadeOutDelay: PropTypes.int, // milliseconds
                loop: PropTypes.bool,
                loopCount: PropTypes.bool,
                showCursor: PropTypes.bool,
                cursorChar: PropTypes.string,
                attr: PropTypes.string,
                contentType: PropTypes.oneOf(['html', 'text']),
                callback: PropTypes.func,
                preStringTyped: PropTypes.func,
                onStringTyped: PropTypes.func,
                resetCallback: PropTypes.func
            }).isRequired
        }
    }

    _id = 'typed' + ((Math.random() * Number.MAX_SAFE_INTEGER) | 0)

    componentDidMount() {
        Typedjs.new('#' + this._id, this.props.options);
    }

    componentWillUnmount() {
        if (this.refs['typed-container'] && this.refs['typed-container']._typed) {
            this.refs['typed-container']._typed.reset();
        }
    }

    render() {
        return <div className={`typed ${this.props.className ? this.props.className : ''}`}>
            <div className="inner-col">
                <span ref="typed-container" id={this._id} className="inner-text" />
            </div>
        </div>
    }
}